import { createWebHistory, createRouter } from "vue-router";
import AdminLoginLayout from "@/layouts/AdminLoginLayout.vue";
import AdminLogin from "@/components/AdminLogin.vue";
import AdminDefaultLayout from "@/layouts/AdminDefaultLayout.vue";
import AdminHome from "@/components/Admin/AdminHome.vue";
import ErrorPage404 from "./components/ErrorPage404.vue";
import UserList from "@/components/Admin/UserList.vue";
import UserMainLayout from "@/layouts/UserMainLayout.vue";
import UserHome from "@/components/User/UserHome.vue";
import TrafficQuote from "@/components/Admin/TrafficQuote.vue";
import PasswordLayout from "@/layouts/PasswordLayout.vue";
import PasswordChange from "@/components/User/PasswordChange.vue";
import PaymentQuote from "@/components/Admin/PaymentQuote.vue";
import { verifyPasswordToken } from "@/api";
import PaymentList from "@/components/Admin/PaymentList.vue";
import UserQuotes from "@/components/Admin/UserQuotes.vue";
import ConnectQuote from "@/components/Admin/ConnectQuote.vue";
import NumberInsert from "@/components/Admin/NumberInsert.vue";
import PrivacyComponent from "@/components/User/PrivacyComponent.vue";
import ServiceComponent from "@/components/User/ServiceComponent.vue";
import DrawList from "@/components/Admin/DrawList.vue";
const routes = [
    {
        path: "/",
        component: UserMainLayout,
        children: [
            { path: "", component: UserHome },
        ]
    },
    {
        path: "/admin_login",
        redirect: "/admin_login/login"
    },
    {
        path: "/admin_login/login",
        component: AdminLoginLayout,
        children: [
            {
                path: "",
                component: AdminLogin,
            }
        ]
    },
    {
        path: "/admin",
        component: AdminDefaultLayout,
        children: [
            {
                path: "home",
                component: AdminHome,
            },
            {
                path: "user_list",
                component: UserList,
            },
            {
                path: "user_quotes",
                component: UserQuotes,
            },
            {
                path: "payment_quote",
                component: PaymentQuote,
            },
            {
                path: "payment_list",
                component: PaymentList,
            },
            {
                path: "traffic_quote",
                component: TrafficQuote,
            },
            {
                path: "connect_quote",
                component: ConnectQuote,
            },
            {
                path: "number",
                component: NumberInsert,
            },
            {
                path: "draw_list",
                component: DrawList,
            }
        ]
    },
    {
        path: "/privacy",
        component: PrivacyComponent,
    },
    {
        path:"/service",
        component:ServiceComponent,
    },
    {
        path: "/:pathMatch(.*)*",
        component: ErrorPage404,
        beforeEnter: (to, from, next) => {
            to.params.message = "올바르지 않은 경로입니다.";
            next();
        }
    },
    {
        path: "/pwd_find",
        component: PasswordLayout,
        children: [
            {
                path: "",
                component: PasswordChange,
                beforeEnter: async (to, from, next) => {
                    let token = to.query.token;
                    let result = await verifyPasswordToken(token);
                    if (result.status === 200) {
                        to.params.token = token;
                        next();
                    } else if (result.status == 401) {
                        next("/pwd_find/expired");
                    } else {
                        next("/pwd_find/error");
                    }
                }
            },
            {
                path: "error",
                component: ErrorPage404,
                beforeEnter: (to, from, next) => {
                    to.params.message = "내부 서버 오류입니다.";
                    next();
                }
            },
            {
                path: "expired",
                component: ErrorPage404,
                beforeEnter: (to, from, next) => {
                    to.params.message = "만료된 토큰입니다.";
                    next();
                }
            },
            {
                path: "success",
                component: ErrorPage404,
                beforeEnter: (to, from, next) => {
                    to.params.message = "비밀번호 재설정 완료.";
                    next();
                }
            }
        ]
    }
];

const router = createRouter({
    history: createWebHistory(),
    routes,
});


export default router; 